import { gql } from '@apollo/client';

import {
  AddScreenerSessionDocument,
  type AddScreenerSessionMutation,
  type AddScreenerSessionMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddScreenerSession($input: AddScreenerSessionInput!) {
      addScreenerSession(input: $input) {
        sessionId
        totalQuestions
        question {
          id
          text
          type
          questionOrder
          options {
            id
            label
            value
          }
        }
      }
    }
  `;
}

export const ADD_SCREENER_SESSION = AddScreenerSessionDocument;
export type { AddScreenerSessionMutation, AddScreenerSessionMutationVariables };
